const reorder = (array, move) => {
  if (!move.destination) {
    return array;
  }

  const result = [...array];
  const element = result.splice(move.source.index, 1)[0];
  result.splice(move.destination.index, 0, element);

  return result;
};

const remove = (array, index) => {
  return [ ...array.slice(0, index), ...array.slice(index + 1, array.length) ];
};

export { reorder, remove };
